import {MutableRefObject} from 'react'

type ScrollToFunction = (
  ref: MutableRefObject<HTMLDivElement | null> | HTMLDivElement | null,
  scrollPosition?: ScrollLogicalPosition,
  scrollBehavior?: ScrollBehavior
) => void

export const scrollTo: ScrollToFunction = (ref, scrollPosition, scrollBehavior = 'smooth') => {
  const htmlElement = ref instanceof HTMLDivElement ? ref : ref?.current

  if (htmlElement) {
    htmlElement.scrollIntoView({behavior: scrollBehavior, block: scrollPosition})
  }
}

type ScrollToTopFunction = (
  ref: MutableRefObject<HTMLDivElement | null> | HTMLDivElement | null,
  scrollBehavior?: ScrollBehavior
) => void

export const scrollToTop: ScrollToTopFunction = (ref, scrollBehavior = 'smooth') => {
  const htmlElement = ref instanceof HTMLDivElement ? ref : ref?.current

  if (htmlElement) {
    htmlElement.scrollTo({
      top: 0,
      behavior: scrollBehavior
    })
  }
}
